import { addLocaleMessages } from '@/i18n';
import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';
import zhTW from './locales/zh-TW';
import jaJP from './locales/ja-JP';

addLocaleMessages('cn', { feedback: zhCN });
addLocaleMessages('tw', { feedback: zhTW });
addLocaleMessages('en', { feedback: enUS });
addLocaleMessages('jp', { feedback: jaJP });
